import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_OPTIONS = {
  selectedTab: 'explore',
  selectedView: 'Front',
  selectedPart: '',
  searchValue: ''
}

const initialState = {
  options: { ...DEFAULT_OPTIONS }
}

const overview = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    UPDATE_OPTIONS: (state, { payload }) => {
      state.options = { ...state.options, ...payload }
    },
    RESET_OPTIONS: (state) => {
      state.options = { ...DEFAULT_OPTIONS }
    }
  }
})

export default overview

export const overviewActions = overview.actions

export const overviewSelectors = {
  selectOverview: ({ overview }) => overview,
  selectOptions: ({ overview }) => overview?.options
}
